.lookup-container {
  display: flex;
  align-items: center;
}

.lookup-container input.error {
  background-color: var(--input-field-error);
}

.lookup-container input {
  border: 0;
  padding: 5px 6px;
  background-color: white;
  box-sizing: border-box;
  color: var(--main-text);
  width: 100%;
  border-right: var(--field-border) 1pt solid;
}

.lookup-container input[disabled] {
  color: var(--main-text-disabled);
}

.lookup-container svg {
  fill: currentcolor;
  cursor: pointer;
  margin: 0 2px;
  width: 1.4em;
  padding-top: 3px;
}
